export const config = {
  NODE_ENV: process.env.NODE_ENV || "production",
  SERVER_ENV: process.env.SERVER_ENV ? "production" : "staging",
  API_URL_STAGING:
    process.env.REACT_APP_API_URL_STAGING ||
    "https://staging-api-perisai.baliola.com/api",
  API_URL_PROD:
    process.env.REACT_APP_API_URL_PROD || "https://api-perisai.baliola.com/api",
};
